import React from "react";




const Devops = () => {
return(
    
<>

<section class="about1" id="">

<div class="max-width" >

<div class="about-content">

<div class=" right">
<div class="text">Devops</div>
<h3>An enthusiastic team delivering beautiful results.<br/>
<span>Our team is the driving force of Shellcode. We're a close-knit bunch of talented individuals with a strong passion for our specialties and a dedication to delivering exceptional results. Each of us brings our unique skill set and love for what we do. Because ultimately, our difference lies in how much we care.
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>HIRE THE BEST<br/>
        <span>
        We move across operations and development fluidly. We include various processes in our methodology to make process management smooth and efficient.<br/>
        Continuous Integration: We resolve any issues related to merging code and bugs using Continuous Integration. Consequently, you get updates that transform into smoother integration.<br/>
        Continuous delivery: We can validate updates as they come through constant development. Testing is essential, and we do not leave any chance to test the software before it launches!<br/>
        </span>
    </h3>
    <h3>DevOps AS A SERVICE<br/>
        <span>
        We use Virtual Development tools that assist clients in the transition to the DevOps model post identification of the drivers and challenges of the business. We ensure a fast and smooth Delivery along with multiple levels of testing and validation so that your product continues to improve with time.<br/>
        DevOps Assessment: Continuous assessment of functions helps us identify the areas where improvement is needed, which further leads to smooth deployment.<br/>
        DevOps Automation: Automated delivery cycles are used to manage deployments in an efficient manner. There are lesser costs and no delays.<br/>
        DevOps Management: Objectives are delivered effortlessly by monitoring the process of development. This leads to a reliable launching of the software.<br/>
        </span>
    </h3>
    <h3>KNOW WHAT YOU'RE GETTING<br/>
        <span>
        Service Virtualization: Due to our expertise in simulation processes, we are more likely to carry out integration testing in the early stages of development.<br/>
        Test Tool Automation: We offer Test Tool Automation which covers performance, accessibility, security, and monitoring of production. Our automation processes lead to quick delivery. <br/>
        Operational Analytics: Operational Analytics let us detect and fix problems as they come. This process of extraction and analysis is automated, thereby reducing effort and increasing productivity.<br/>
        Release Planning and Monitoring: We plan, we deliver. We monitor the development process throughout and ensure that you get everything on time!<br/>
        </span>
    </h3>
    <h3>OUR PROCESS<br/>
        <span>
        We have created a process for our DevOps projects which increases our efficiency and minimizes hassle. <br/>
        Knowing our clients: The first step is knowing our clients and understanding their needs and requirements. We prioritize our clients and make their needs our commands.<br/>
        Onboarding: We begin the development process with conceptualization and designing. After a meticulous development process, we deliver our product to the client.<br/>
        Further Improvements: We check for any scope of improvement in the product that we have delivered. Our dexterous employees work efficiently to deliver the best!<br/>
        Support and Maintenance: Our job does not end with product delivery. We stay with you in case you need our support. </span>
    </h3>
    <h3>WATCH US GROW<br/>
        <span>
        Get a glimpse of our success story and witness how we tackle challenges that come our way!</span>
    </h3>
</div>


    </>
)
}

export default Devops;
